import React from 'react';
import { useIntl } from 'react-intl';

import SimilarRentalsCarousel from '@/components/common/SimilarRentalsCarousel';
import Button, { ButtonSize, ButtonVariants } from '@/components/switchback/Button/Button';
import { EListingSource } from '@/services/analytics/listings/types';

interface IRentalsList {
  goToRentals: (event: React.MouseEvent<HTMLButtonElement>) => void;
  eventSource?: EListingSource;
}

export const RentalsInlineList: React.FC<IRentalsList> = ({ goToRentals, eventSource }) => {
  const intl = useIntl();

  return (
    <>
      <div className="flex flex-col w-full px-0 mt-4 mb-8 max-w-xxl">
        <SimilarRentalsCarousel inline eventSource={eventSource} />
      </div>

      <div className="flex justify-center">
        <div className="mx-4">
          <Button
            onClick={goToRentals}
            size={ButtonSize.large}
            variant={ButtonVariants.primaryOutlined}>
            {intl.formatMessage({ defaultMessage: 'See all rentals', id: 'AI18Hm' })}
          </Button>
        </div>
      </div>
    </>
  );
};
